import {
  BizNestClientError, EhttpController,
  FrontendLogger,
  IehttpControllerConfig
} from '@biz-nest/core-client';

/**
 * Client for interacting with the Auto Cloud DNS service.
 * Provides a static HTTP client for making API requests to manage DNS records.
 */
export class AutoCloudDnsClient {
  /** Static HTTP controller instance for making requests */
  private static http: EhttpController;

  /**
   * Creates an instance of AutoCloudDnsClient.
   * @param config - Configuration object for the HTTP client
   * @throws {BizNestClientError} If the provided config is invalid
   */
  constructor(config: IehttpControllerConfig) {
    if (!config || typeof config !== 'object') {
      throw new BizNestClientError('Configuration must be a valid object');
    }

    FrontendLogger.debug('AutoCloudDnsClient initialized');
    AutoCloudDnsClient.http = new EhttpController(config);
  }

  /**
   * Gets the HTTP client instance.
   * @returns {EhttpController} The HTTP client instance
   * @throws {BizNestClientError} If the client is not initialized
   */
  static get ehttp(): EhttpController {
    if (!AutoCloudDnsClient.http) {
      throw new BizNestClientError('HTTP client not initialized. Call new AutoCloudDnsClient() first.');
    }

    return AutoCloudDnsClient.http;
  }
}
